import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import baseUrl from "../../../../../../../../api/baseUrl";
import CloseIcon from "@mui/icons-material/Close";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
type FormDataType = {
  treatmentkey: number;
  treatment: string;
  treatments: string;
  treatmentId: string;
  type: string;
  types: string;
  typeId: string;
  subtype: string;
  subtypes: string;
  subtypeId: string;
  toothNos: string;
  toothNo: string;
  prices: number;
  price: number;
  description: string;
  createdAt: Date;
  quantity: number;
  note: string;
  surface: string;
  didBy?: string; // Make didBy optional
};
function TreatmentFormModal({
  setaddTreatmentOpent,
  settreatment,
  treatment,
  fetchData,
}: any) {
  const { ID } = useParams();
  const [openOther, setopenOther] = useState(false);
  const [otherserror, setotherserror] = useState(false);
  const [error, seterror] = useState(false);
  const [data, setData] = useState([]);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const initialFormData: FormDataType = {
    treatmentkey: treatment.length + 1,
    treatment: "",
    treatments: "",
    treatmentId: "",
    type: "",
    types: "",
    typeId: "",
    subtype: "",
    subtypes: "",
    subtypeId: "",
    toothNos: "",
    toothNo: "",
    prices: 0,
    price: 0,
    description: "",
    createdAt: new Date(),
    quantity: 1,
    note: "",
    surface: "",
  };

  const [formData, setformData] = useState(initialFormData);

  useEffect(() => {
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        console.log(response.data.data);

        setData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const onchange = (e: any) => {
    const { value, name } = e.target;

    if (name === "treatments") {
      if (value === "others") {
        setopenOther(true);
        setformData((prevState) => ({
          ...prevState,
          [name]: value,
          prices: 0,
          treatment: value,
          treatmentId: value,
        }));
      } else {
        setopenOther(false);

        const separatedArray = value.split("/");

        setformData((prevState) => ({
          ...prevState,
          [name]: value,
          treatmentId: separatedArray[0],
          treatment: separatedArray[1],
          prices: separatedArray[2],
        }));
      }
    } else {
      if (formData.treatment === "others") {
        if (name === "types") {
          const separatedArray = value.split("/");
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            typeId: separatedArray[0],
            type: separatedArray[1],
            prices: separatedArray[2],
          }));
        } else if (name === "subtypes") {
          const separatedArray = value.split("/");
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            subtypeId: separatedArray[0],
            subtype: separatedArray[1],
            prices: separatedArray[2],
          }));
        } else if (name === "quantity") {
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            // price: formData.quantity
          }));
        } else if (name === "note") {
          if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reset height
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height to fit content
          }
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            // price: formData.quantity
          }));
        } else {
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
      } else {
        if (name === "types") {
          const separatedArray = value.split("/");
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            typeId: separatedArray[0],
            type: separatedArray[1],
            prices: separatedArray[2],
          }));
        } else if (name === "subtypes") {
          const separatedArray = value.split("/");
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            subtypeId: separatedArray[0],
            subtype: separatedArray[1],
            prices: separatedArray[2],
          }));
        } else if (name === "quantity") {
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            // price: formData.quantity
          }));
        } else if (name === "prices") {
          setformData((prevState) => ({
            ...prevState,
          }));
        } else if (name === "note") {
          if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reset height
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height to fit content
          }
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
            // price: formData.quantity
          }));
        } else {
          setformData((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
      }
    }
  };

  const onsubmit = (e: any) => {
    e.preventDefault();
    if (ID) {
      if (formData.treatments !== "") {
        seterror(false);

        if (formData.treatments === "others") {
          if (formData.description !== "" && formData.prices > 0) {
            settreatment([
              ...treatment,
              {
                ...formData,
                treatment: formData.description,
                price: formData.prices * formData.quantity,
              },
            ]);
            baseUrl
              .post(
                "treatment/add-treatments",
                {
                  ...formData,
                  treatment: formData.description,
                  price: formData.prices * formData.quantity,
                },
                {
                  headers: {
                    treatmentid: ID,
                  },
                }
              )
              .then((response) => {
                fetchData();

                setaddTreatmentOpent(false);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            setotherserror(true);
          }
        } else {
          settreatment([
            ...treatment,
            { ...formData, price: formData.prices * formData.quantity },
          ]);
          const price = formData.prices * formData.quantity;
          baseUrl
            .post(
              "treatment/add-treatments",
              { ...formData, price },
              {
                headers: {
                  treatmentid: ID,
                },
              }
            )
            .then((response) => {
              fetchData();

              setaddTreatmentOpent(false);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else {
        seterror(true);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between bg-gradient-to-r from-emerald-500 to-teal-600">
          <div className="flex items-center gap-3">
            <MedicalServicesIcon className="text-white" />
            <h2 className="text-xl font-bold text-white">Add Treatment</h2>
          </div>
          <button
            onClick={() => setaddTreatmentOpent(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onsubmit} className="flex-1 overflow-y-auto p-6 space-y-4">
          {/* Treatment Select */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Select Treatment *</label>
            <select
              onChange={onchange}
              value={formData.treatments}
              name="treatments"
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
            >
              <option value="">Select treatment</option>
              {data
                ?.slice()
                .sort((a: any, b: any) => a.treatment.localeCompare(b.treatment))
                ?.filter((item: any) => item.status1 === true)
                .map((item: any, i: number) => (
                  <option key={i} value={item._id + "/" + item.treatment + "/" + item.price}>
                    {item.treatment}
                  </option>
                ))}
              <option value="others">Others</option>
            </select>
            {error && formData.treatments === "" && (
              <p className="text-xs text-red-500 mt-1">Treatment is required</p>
            )}
          </div>

          {/* Type Select */}
          {data
            ?.filter((item: any) => item._id === formData.treatmentId)
            ?.slice()
            .sort((a: any, b: any) => a.treatment.localeCompare(b.treatment))
            ?.map((filteredItem: any) => filteredItem.type)
            ?.flat().length > 0 && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Select Type</label>
              <select
                onChange={onchange}
                value={formData.types}
                name="types"
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              >
                <option value="">Select type</option>
                {data
                  ?.filter((item: any) => item._id === formData.treatmentId)
                  ?.map((filteredItem: any) => filteredItem.type)
                  ?.flat()
                  .map((item: any, i: number) => (
                    <option key={i} value={item._id + "/" + item.treatment + "/" + item.price}>
                      {item.treatment}
                    </option>
                  ))}
              </select>
            </div>
          )}

          {/* Subtype Select */}
          {data
            ?.filter((item: any) => item._id === formData.treatmentId)
            .map((filteredItem: any) => filteredItem.type)
            ?.flat()
            ?.filter((item: any) => item._id === formData.typeId)
            ?.slice()
            .sort((a: any, b: any) => a.treatment.localeCompare(b.treatment))
            .map((filteredItem: any) => filteredItem.subType)
            ?.flat().length > 0 && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Select Subtype</label>
              <select
                onChange={onchange}
                value={formData.subtypes}
                name="subtypes"
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              >
                <option value="">Select subtype</option>
                {data
                  ?.filter((item: any) => item._id === formData.treatmentId)
                  .map((filteredItem: any) => filteredItem.type)
                  ?.flat()
                  ?.filter((item: any) => item._id === formData.typeId)
                  .map((filteredItem: any) => filteredItem.subType)
                  ?.flat()
                  .map((item: any, i: number) => (
                    <option key={i} value={item._id + "/" + item.treatment + "/" + item.price}>
                      {item.treatment}
                    </option>
                  ))}
              </select>
            </div>
          )}

          {/* Price & Quantity */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Price *</label>
              <input
                value={formData.prices}
                name="prices"
                type="number"
                onChange={onchange}
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              />
              {otherserror && formData.prices <= 0 && (
                <p className="text-xs text-red-500 mt-1">Price must be greater than 0</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Quantity</label>
              <input
                value={formData.quantity}
                name="quantity"
                type="number"
                onChange={onchange}
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              />
            </div>
          </div>

          {/* Description (for Others) */}
          {openOther && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Description *</label>
              <input
                value={formData.description}
                name="description"
                type="text"
                onChange={onchange}
                placeholder="Enter treatment description"
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              />
              {otherserror && formData.description === "" && (
                <p className="text-xs text-red-500 mt-1">Description is required for others</p>
              )}
            </div>
          )}

          {/* Tooth No & Surface */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Tooth No</label>
              <input
                value={formData.toothNo}
                name="toothNo"
                type="number"
                onChange={onchange}
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Surface</label>
              <input
                value={formData.surface}
                name="surface"
                type="text"
                onChange={onchange}
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
              />
            </div>
          </div>

          {/* Note */}
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Note</label>
            <textarea
              ref={textareaRef}
              value={formData.note}
              name="note"
              onChange={onchange}
              rows={3}
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all resize-none"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-medium hover:shadow-lg hover:shadow-emerald-200 transition-all"
          >
            Add Treatment
          </button>
        </form>
      </div>
    </div>
  );
}

export default TreatmentFormModal;
